import {createActions} from 'rlink-flux';

let TITLE_MULTIPLIER = 3; // used in api requests to increase the limit to a reasonable amount because we filter games after the request has been made

export let twitchActions = createActions({
  LoadBroadcasts (payload) {
    let service = payload.service;
    //load streams
    for (let i = 0; i < payload.channels.length; i++) {
      if (payload.channels[i].getStream) {
        let channelName = payload.channels[i].channelName;
        let channelPriority = payload.channels[i].priority || 0;
        let thumbnail = payload.channels[i].thumbnail;
        service.getChannelStream(channelName).then(response => {
          if (response.streams) { //stream is live
            twitchActions.BroadcastLoaded({
              broadcasts: response.streams,
              gameFilter: payload.gameFilter,
              priority: channelPriority,
              groupId: payload.groupId,
              thumbnail,
            });
          }
        });
      }
      //@todo: handle errors here
    }
    //load videos
    let apiLimit = payload.maxChildren * TITLE_MULTIPLIER || 10; // 10 is the default
    apiLimit = (apiLimit > 100) ? 100 : apiLimit; // 100 is the max
    for (let i = 0; i < payload.channels.length; i++) {
      if (payload.channels[i].getVideo) {
        let channelName = payload.channels[i].channelName;
        let channelPriority = payload.channels[i].priority || 0;
        service.getChannelVideos(channelName, apiLimit).then(response => {
          twitchActions.BroadcastLoaded({
            service: service,
            broadcasts: response.broadcasts,
            gameFilter: payload.gameFilter,
            priority: channelPriority,
            groupId: payload.groupId,
            desiredAmount: payload.maxChildren,
            channelName: channelName,
            nextPage: response.nextPage
          });
        });
        //@todo: handle errors here
      }
    }
  },
  GetNextPage (payload) {
    let service = payload.service;
    service.getNextPage(payload.nextPage).then(response => {
      twitchActions.BroadcastLoaded(Object.assign(payload, {
        broadcasts: response.broadcasts,
        nextPage: response.nextPage
      }));
    });
  },
  BroadcastLoaded (payload) {
    if (payload.desiredAmount) {
      let broadcasts = payload.broadcasts
      let validBroadcasts = broadcasts.filter(broadcast => {
        return (broadcast.game === payload.gameFilter);
      });

      if (broadcasts.length > 0 && // and we actually got new broadcasts
        payload.desiredAmount > validBroadcasts.length) { // check if we need to paginate
        let page = payload;
        payload.service.getNextPage(page.nextPage).then((response) => {
          twitchActions.BroadcastLoaded(Object.assign(payload,
          {
            broadcasts: response.broadcasts,
            maxChildren: payload.desiredAmount - validBroadcasts.length,
            nextPage: response.nextPage
          }));
        });
      }

      payload.broadcasts = validBroadcasts;
    }
    return payload;
  }
});



// WEBPACK FOOTER //
// ./lib/rlink-twitch/actions.js